import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import { CmsFormTemplateContainerModel } from '../../../../../../models/aggregates/cms/form';

@Injectable({providedIn: 'root'})

export class CmsFormTemplateService extends BaseApiTemplateService<CmsFormTemplateContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'form-templates';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'form-templates';
        this.httpClient = http;
      }

      addImageAndDetails(formData: FormData, formTemplateGuid, visa: ApiVisa) {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const url = this.apiUrl + '/file/' + formTemplateGuid + '/upload';
        return this.httpClient.post(url, formData, this.getHttpHeader(visa));
      }
    
      replaceImageAndDetails(formData: FormData, extGuid, visa: ApiVisa) {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const url = this.apiUrl + '/replace-file/' + extGuid;
        return this.httpClient.put(url, formData, this.getHttpHeader(visa));
      }

      getImageDetails(extGuid, visa: ApiVisa) {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const url = this.apiUrl + '/file/' + extGuid;
        return this.httpClient.get(url, this.getHttpHeader(visa));
      }

      deleteImageDetails(extGuid, visa: ApiVisa) {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const url = this.apiUrl + '/file/' + extGuid;
        return this.httpClient.delete(url, this.getHttpHeader(visa));
      }
    
    
}